"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Modal = _interopRequireDefault(require("../../common/Modal/Modal"));
var _ConfirmCyclicalReportForm = _interopRequireDefault(require("./ConfirmCyclicalReportForm"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var ConfirmCyclicalReportModal = function ConfirmCyclicalReportModal(props) {
  var _useTranslation = (0, _reactI18next.useTranslation)("core"),
    t = _useTranslation.t;
  return /*#__PURE__*/_react["default"].createElement(_Modal["default"], {
    isOpen: props.isOpen,
    title: t("Schedule a Cyclical Report"),
    customClass: "confirm-report-modal",
    close: props.close,
    footer: {
      buttonText: t("Schedule Report"),
      buttonStyle: 'additive',
      onClick: function onClick() {
        return props.scheduleReport(props.payload);
      }
    }
  }, /*#__PURE__*/_react["default"].createElement(_ConfirmCyclicalReportForm["default"], {
    payload: props.payload
  }));
};
ConfirmCyclicalReportModal.propTypes = {
  payload: _propTypes["default"].object,
  close: _propTypes["default"].func.isRequired
};
ConfirmCyclicalReportModal.defaultProps = {
  payload: {
    type: '',
    startDate: '',
    frequency: ''
  }
};
var _default = exports["default"] = ConfirmCyclicalReportModal;